// SQL null type field extractors
export const SQL_NULL_TYPES = {
  Int32: (field) => (field.Valid ? field.Int32 : null),
  Int64: (field) => (field.Valid ? field.Int64 : null),
  Float64: (field) => (field.Valid ? field.Float64 : null),
  String: (field) => (field.Valid ? field.String : null),
  Bool: (field) => (field.Valid ? field.Bool : null),
  Time: (field) => (field.Valid ? new Date(field.Time) : null),
};

/**
 * Helper to extract values from nullable database fields (Go sql.Null* types)
 * @param {*} field - The field to extract value from
 * @param {*} defaultValue - Optional default value to return for null/invalid fields (default: null)
 * @returns {*} The extracted value or defaultValue
 */
export const extractValue = (field, defaultValue = null) => {
  if (field === null || field === undefined) return defaultValue;

  if (typeof field === 'object' && field.Valid !== undefined) {
    for (const [type, extractor] of Object.entries(SQL_NULL_TYPES)) {
      if (Object.hasOwn(field, type)) {
        const value = extractor(field);
        return value !== null ? value : defaultValue;
      }
    }
  }

  return field;
};
